module.exports = __webpack_public_path__ + "static/media/BT.4971f00c.png";